import React from "react";
import { Form } from "antd-mobile";
import { BaseFormItemProps } from "./Form.types";
import "./Form.scss";

const AntdMobileFormItem = Form.Item;

export const FormItem: React.FC<BaseFormItemProps> = ({
  children,
  className = "",
  testId,
  layout = "vertical",
  required = false,
  disabled = false,
  hidden = false,
  ...props
}) => {
  const formItemClass = [
    "base-form-item",
    `base-form-item--${layout}`,
    required && "base-form-item--required",
    disabled && "base-form-item--disabled",
    hidden && "base-form-item--hidden",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (hidden) {
    return null;
  }

  return (
    <AntdMobileFormItem
      className={formItemClass}
      layout={layout}
      required={required}
      disabled={disabled}
      data-testid={testId}
      {...props}
    >
      {children}
    </AntdMobileFormItem>
  );
};

FormItem.displayName = "BaseFormItem";

export default FormItem;
